import home from './home'
import enums from './enums'
import staticPages from './static'
import site from './site'
import domains from './domains'
import sidebarMenu from './sidebarMenu'

export default {
  sidebarMenu,
  home,
  enums,
  site,
  domains,
  static: staticPages
}
